// Path: ./src/hooks/useStores.ts
import { useState, useEffect, useCallback, useContext } from "react";
import { adminApiService } from "../utils/api";
import { GfStore } from "@swagger/typescript-fetch-goflyer";
import { debounce } from "../utils/debounce";
import { GoFlyerAdminContext } from "../contextApi/context";
import { SUPERADMIN } from "../utils/constant/stringConstant";

export const useStores = () => {
  const [storesList, setStoresList] = useState<GfStore[]>(); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) maybe we should do the mapping here to create label
  const [isStoreOptionLoading, setIsStoreOptionLoading] = useState(false);
  const { state } = useContext(GoFlyerAdminContext);

  const fetchStores = useCallback(async () => {
    try {
      if (
        state.user?.parsedRoles?.name === SUPERADMIN ||
        !state.user?.stores?.length
      ) {
        const conditions = [];
        const storesList =
          state.user?.parsedRoles?.name === SUPERADMIN
            ? []
            : state.user?.merchant?.map((value) => {
                return `${value.id}`;
              }) || [];

        if (storesList && storesList.length) {
          conditions.push(`id||$in||${storesList?.join(",")}`);
        }

        const stores =
          await adminApiService.getManyBaseGfStoreAdminControllerGfStore(
            undefined,
            undefined,
            conditions?.length ? conditions : undefined,
            undefined,
            undefined,
            undefined,
            100,
            0,
            1,
            undefined
          );

        setStoresList(stores.data);
      } else {
        /**
         *So here, if a user is super admin, then the store array is going to be empty. And if a user is a department manager, or I would say is not a super admin, then there will be some store in the array, meaning that this user is managing some stores.
         */
        if (state.user?.stores && state.user?.stores?.length > 0) {
          setStoresList(state.user?.stores);
        }
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  }, []);

  const handleOnStoreSearch = useCallback(
    debounce(async (value: string) => {
      if (
        state.user?.merchant?.length &&
        state.user?.parsedRoles?.name !== SUPERADMIN
      ) {
        return;
      }
      if (value === "") {
        return;
      }
      setIsStoreOptionLoading(true);
      //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) you can't search if for other role?
      const searchTextValue = value.trim().toLowerCase();
      const response = await adminApiService.gfStoreAdminControllerSearch(
        `${searchTextValue}`,
        1 as number,
        100 as number
      );

      //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) will improve this logic. not sure why we need const uniqueMap = new Map(); logic previously
      setStoresList(response.data);

      setIsStoreOptionLoading(false);
    }, 500),
    []
  );

  useEffect(() => {
    fetchStores();
  }, []);

  return { storesList, isStoreOptionLoading, fetchStores, handleOnStoreSearch };
};
